import {
  Button,
  DialogActions,
  DialogContent,
  Tooltip
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postSession } from "../../../../../../actions/appointments";
import { getFormProfessionalSpecialties } from "../../../../../../actions/forms";
import { openNewForm } from "../../../../../../actions/formsState";
import { convertDateTimeToNet } from "../../../../../../utils/datetimeUtils";
import snackbarUtils from "../../../../../../utils/snackbarUtils";
import CustomDialog from "../../../../../commons/dialog/customDialog";
import CircularLoading from "../../../../../commons/loadingData/circularLoading";
import { StyledAppointmentsSession } from "../../../../../styled/appointments";
import { StyledFormHeader } from "../../../../../styled/form";
import AppointmentSessionCalendar from "./appointmentSessionCalendar";
import AppointmentSessionCards from "./appointmentSessionCards";
import AppointmentSessionHeader from "./appointmentSessionHeader";

const AppointmentSession = ({
  open,
  appointment,
  handleClose,
  handleOpenConfirmDialog,
  artId,
  siniestro,
  nroFormulario,
  callBack,
  hasFpt,
  trabajador,
  handleSubmit,
}) => {
  const dispatch = useDispatch();

  const session = useSelector((state) => state.appointments.postSession);
  const professionalSpecialties = useSelector(
    (state) => state.forms.professionalSpecialties,
  );

  const [appointments, setAppointments] = useState([]);
  const [disableGuardarSesiones, setDisableGuardarSesiones] = useState(false);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    setAppointments([{ ...appointment }]);
  }, [appointment]);

  useEffect(() => {
    if (open && artId) {
      dispatch(getFormProfessionalSpecialties(artId));
    }
  }, [artId]);

  const handleAddAppointment = (date) => {
    if (date > appointment.fechaHora) {
      const newAppointment = { ...appointment, fechaHora: date };

      newAppointment.fechaHora.setHours(appointment.fechaHora.getHours());
      newAppointment.fechaHora.setMinutes(appointment.fechaHora.getMinutes());

      if (
        !appointments.find(
          (a) =>
            moment(a.fechaHora).dayOfYear() ===
            moment(newAppointment.fechaHora).dayOfYear(),
        )
      ) {
        setAppointments((prevState) => [...prevState, newAppointment]);
      } else {
        snackbarUtils.error("Ya tiene un turno agregado para esta fecha");
      }
    } else {
      snackbarUtils.error("No es posible agregar un turno para esta fecha");
    }
  };

  const handleDeleteAppointment = (appointment) => {
    setAppointments(
      appointments.filter(
        (a) => a.fechaHora.getTime() !== appointment.fechaHora.getTime(),
      ),
    );
  };

  const setTrasladoAppointment = (appointment) => {
    const appointmentAux = appointments;
    appointmentAux.forEach((e) => {
      if (e.fechaHora.getTime() === appointment.fechaHora.getTime()) {
        e.traslado = !e.traslado;
      }
    });
    setAppointments([...appointmentAux]);
  };

  const validateAppointments = (appointments) => {
    let newErrors = {};
    appointments.forEach((appointment, appointmentIndex) => {
      if (appointment.fechaHora <= new Date()) {
        newErrors[`appointments[${appointmentIndex}]`] =
          "La hora del turno no puede ser menor a la hora actual";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length > 0;
  };

  const setAppointmentHs = (index, time) => {
    if (time != "Invalid Date" && time != null) {
      const appointmentAux = appointments;

      if (appointmentAux[index]) {
        appointmentAux[index].fechaHora = moment(time)
          .date(moment(appointmentAux[index].fechaHora).date())
          .month(moment(appointmentAux[index].fechaHora).month())
          .toDate();
      }
      validateAppointments(appointmentAux);
      setAppointments([...appointmentAux]);
    }
  };

  const handleSubmitSession = (shouldOpenFpt) => {
    if (validateAppointments(appointments)) {
      // No hay submit si hay un error
      return;
    }
    const model = [];
    const especialidad = professionalSpecialties.data.find(
      (e) => e.id == appointments[0].especialidad,
    );
    appointments.forEach((a) => {
      model.push({
        ...a,
        fechaHora: convertDateTimeToNet(a.fechaHora),
        especialidadNombre: especialidad.nombre,
      });
    });
    if (handleSubmit) {
      // Handle Submit particular
      handleSubmit(model, shouldOpenFpt);
    } else {
      // Handle submit default
      dispatch(postSession(model, artId, siniestro, nroFormulario)).then(
        (res) => {
          if (callBack) {
            callBack();
          }
          handleClose();
          snackbarUtils.success("Sesión de turnos creada correctamente");
          if (shouldOpenFpt) {
            dispatch(
              openNewForm("Fpt", "Formulario de Pedido de Traslado", {
                professionalName: model[0].profesionalApellidoNombre, // Todos tienen el mismo profesional y especialidad
                specialityName: model[0].especialidadNombre,
                appointmentDates: model
                  .filter((e) => e.traslado == true)
                  .map((e) => e.fechaHora),
                appointmentsIds: res.value?.data,
              }),
            );
          }
        },
      );
    }
  };

  const handleSetDisableSave = (bool) => {
    setDisableGuardarSesiones(bool);
  };

  return (
    <div>
      <CustomDialog
        open={open}
        onClose={handleOpenConfirmDialog}
        maxWidth="md"
      >
        <StyledAppointmentsSession.TitleContainer>
          <StyledAppointmentsSession.Title>
            SESIÓN DE TURNOS
          </StyledAppointmentsSession.Title>
          <Tooltip title="Cerrar">
            <StyledFormHeader.CloseIcon onClick={handleOpenConfirmDialog} />
          </Tooltip>
        </StyledAppointmentsSession.TitleContainer>
        {session.isFetching ? (
          <StyledAppointmentsSession.Loading>
            <CircularLoading />
          </StyledAppointmentsSession.Loading>
        ) : (
          <div>
            <DialogContent>
              <StyledAppointmentsSession.Container>
                <AppointmentSessionHeader
                  appointment={appointment}
                  siniestro={siniestro}
                  trabajador={trabajador}
                />
                <StyledAppointmentsSession.AppointmentsContainer>
                  <AppointmentSessionCalendar
                    onClick={handleAddAppointment}
                    appointment={appointment}
                  />
                  <AppointmentSessionCards
                    data={appointments}
                    onDelete={handleDeleteAppointment}
                    setTraslado={setTrasladoAppointment}
                    handleChangeDate={setAppointmentHs}
                    handleSetDisableSave={handleSetDisableSave}
                  />
                </StyledAppointmentsSession.AppointmentsContainer>
              </StyledAppointmentsSession.Container>
            </DialogContent>
            <StyledAppointmentsSession.ActionsContainer>
              <DialogActions>
                <Button onClick={handleOpenConfirmDialog} color="primary">
                  Cancelar
                </Button>
                <Button
                  onClick={() => {
                    handleSubmitSession(
                      appointments.find((a) => a.traslado == true) && hasFpt,
                    );
                  }}
                  color="primary"
                  variant="contained"
                  disabled={!appointments.length || disableGuardarSesiones}>
                  Guardar Sesión
                </Button>
              </DialogActions>
            </StyledAppointmentsSession.ActionsContainer>
          </div>
        )}
      </CustomDialog>
    </div>
  );
};

export default AppointmentSession;
